export default __webpack_public_path__ + "static/media/portfolio-1.6dd6354d.jpg";